import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4xhf67vcvr: FaireBrandEntity = {
  token: "b_4xhf67vcvr",
  type: "brand",
  name: "Out The Dough",
  avatarUrl:
    "https://cdn.faire.com/fastly/c07e6fe89cf21f14d01cc499aa9fa5b87bd618ec96f4416a999e87ca355acacb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/85e97c971221c3d330fb9643d33c10c5a9b56653b43d146202003b8665c50dc1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c07e6fe89cf21f14d01cc499aa9fa5b87bd618ec96f4416a999e87ca355acacb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/85e97c971221c3d330fb9643d33c10c5a9b56653b43d146202003b8665c50dc1.jpeg",
  location: "Martinez, CA, USA",
  minimumOrderDollars: 83,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: true,
  description:
    'Angelo, CEO and co-founder of Out The Dough, Inc., recognized a unique opportunity in the evolving dessert landscape. Driven by a desire to build a family-run legacy, Angelo alongside his Mother, Jill, together spearheaded the creation of Out The Dough, a vibrant brand offering a diverse selection of classic and innovative cookie dough treats. Together with their dedicated team, Angelo & Jill have established Out The Dough as a leader in inclusivity, with vegan and gluten-free options ensuring everyone can participate in the enjoyment with that delicious side of nostalgia. Embrace the legacy of family and delectable creations in which Out The Dough redefines cookie dough for the modern world. \n"We combine the nostalgic taste and texture of your favorite treat with innovative ingredients that let you enjoy it straight away. No eggs & all pasteurized ingredients, like heat-treated flour – just safe, delicious, and guilt-free indulgence in every bite. Experience the future of cookie dough, one BITE at a time."\n',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.600Z",
    importedBy: "entity-db-cli",
  },
};
